module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/flash-back-video.ee0ff859.mp4";